import { IContactForm } from "store/entities/contact-forms/interfaces";

export const DEFAULT_SETTINGS: Omit<IContactForm, "id" | "teamID" | "licenseID" | "name"> = {
  header: "Contact us",
  caption: "Your thoughts are important to us. To submit comments or questions, please complete the form below.",
  confirmation: "Thank you! We'll contact you as soon as possible.",
  nameLabel: "Name",
  emailLabel: "Email",
  subjectLabel: "Subject",
  messageLabel: "Message",
  sendLoadingLabel: "Submitting",
  sendErrorMessage: "Unfortunately, there was an error processing your request.\nPlease try again later.",
  namePlaceholder: "",
  emailPlaceholder: "",
  subjectPlaceholder: "",
  messagePlaceholder: "",
  sendLabel: "Send",
  sendSuccessLabel: "Success!",
  consentMessage:
    "I understand that the controller of my personal data is [your company name] with its registered office in [your business address]. I acknowledge that my personal data shall be processed and transmitted in accordance with the General Data Protection Regulation (GDPR). [Full policy](https://yourcompany.com/fullpolicy)",
  consentMode: "disabled",
  sendErrorLabel: "Error 😿",
  nameRequiredError: "Name can't be blank",
  emailRequiredError: "Email can't be blank",
  emailInvalidError: "Invalid email address",
  subjectRequiredError: "Subject can't be blank",
  messageRequiredError: "Message can't be blank",
  consentRequiredError: "You need to give your consent to process your personal data.",
  livechatGroupIDs: [],
};

export const DEFAULT_LIVECHAT_CONTACT_FORM_ID = "default";
